module.exports = __webpack_public_path__ + "img/sps-logo.e1199d97.png";